<form [formGroup]="dataForm.form">
  <app-admin-form [dataForm]="dataForm" [title]="'admin.inventario.fuente.dialog_title'">
    <ng-template let-form="form">
      <div class="row p-0 mt-4 mb-4">
        <mat-form-field class="col-sm-12" [floatLabel]="'always'">
          <mat-label>{{'models.fuente.NOMBRE.label' | translate }}</mat-label>
          <input type="TEXT" matInput formControlName="NOMBRE" required>
        </mat-form-field>
      </div>
    </ng-template>
  </app-admin-form>
</form>
